
/* styles */
require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-27e66917\",\"scoped\":true,\"hasInlineConfig\":false}!../vue-loader/lib/selector?type=styles&index=0!./vue-datepicker-es6.vue")

var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./vue-datepicker-es6.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-27e66917\"}!../vue-loader/lib/selector?type=template&index=0!./vue-datepicker-es6.vue"),
  /* scopeId */
  "data-v-27e66917",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker/vue-datepicker-es6.vue
// module id = 6
// module chunks = 1